<template>

  <el-dialog width="600px" append-to-body title="修改密码" center="" :visible.sync="visible" :before-close="handleClose">
    <el-form :model="form" :rules="formRules" status-icon ref="form" label-width="0px"
      style="width: 360px;margin: 0 auto;">
      <el-form-item label="" prop="phone">
        <el-input v-model="form.phone" readonly placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="" prop="code">
        <el-input v-model="form.code" placeholder="短信验证码">
          <template slot="append">
            <el-button @click="sendCode">{{ text }}</el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="password">
        <el-input v-model="form.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="" prop="repassword">
        <el-input v-model="form.repassword" placeholder="请输入确认密码"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button v-waves type="primary" @click.native.prevent="handleSubmit" native-type="submit"
        :loading="loading">确认修改</el-button>
    </div>
    <!-- 滑动验证码 -->
    <Verify ref="verify" @success="captchaSuccess" mode="pop" :captchaType="form.captchaType"
      :imgSize="{ width: '330px', height: '155px' }"></Verify>
  </el-dialog>
</template>

<script>
import { getUserPhone, setPassword } from '@/api/user'
import { sendCode } from "@/api/common";
import { validatePhone } from "@/utils/validate";
import { getStorage } from "@/utils/auth";
import waves from '@/directive/waves'; // 水波纹指令
//引入组件
import Verify from "@/components/verifition/Verify";
export default {
  name: 'changePassword',
  components: {
    Verify
  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.getUserPhone();
      }
    }
  },
  data() {
    var validatePwd = (rule, value, callback) => {
      const passwordPattern = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{8,}$/
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!passwordPattern.test(value)) {
        callback(new Error('密码长度至少8位，数字/字母/特殊字符至少包含三种'));
      } else {
        callback();
      }
    }
    var validateRepeatPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      disabled: false,
      countdown: 60,
      text: "发送验证码",
      config: {},
      form: {
        phone: getStorage("loginPhone") || '',
        password: '',
        repassword: '',
        code: '',
        captchaType: "blockPuzzle",
        captchaVerification: "",
      },
      timer: null,
      formRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePwd, trigger: 'blur' }
        ],
        repassword: [
          { required: true, validator: validateRepeatPwd, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    getUserPhone() {
      getUserPhone({}).then(response => {
        this.form.phone = response.data
      }).catch(() => {

      })
    },
    sendCode() {
      const that = this
      const _form = that.form;
      if (that.disabled) return
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      console.log(_form)
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      that.disabled = true
      sendCode(that.form).then((res) => {
        that.timer = setInterval(() => {
          that.countdown--
          this.text = "重新发送(" + that.countdown + "s)"
          if (that.countdown == 0) {
            that.disabled = false
            that.text = '发送验证码'
            that.countdown = 60
            clearInterval(that.timer)
          }
        }, 1000)

        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '短信发送成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    captchaSuccess(params) {
      console.log(params);
      this.form = {
        ...this.form,
        ...params,
      }
      this.sendCode()
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    //修改密码
    handleSubmit() {
      const _form = this.form;
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      if (!_form.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return;
      }
      if (_form.password != _form.repassword) {
        this.$message({
          type: 'error',
          message: '密码和确认密码不一致'
        });
        return;
      }
      if (!_form.code) {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        });
        return;
      }
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      this.loading = true;
      setPassword(_form).then((res) => {
        this.loading = false;
        this.form.captchaVerification = '';
        this.$message({
          type: 'success',
          message: '密码修改成功，请重新登录！'
        }), this.$router.push('/auth/login')
      }).catch((err) => {
        this.form.captchaVerification = '';
        this.loading = false;
      })
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      // 更新visible参数
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>